// extracted by mini-css-extract-plugin
module.exports = {"main":"StatusDeclined_main__NRf6Q"};